module.exports = __webpack_public_path__ + "static/media/18.cb9a60c4.JPG";